import { render } from "./orderProgress.vue?vue&type=template&id=6e12470c"
import script from "./orderProgress.vue?vue&type=script&lang=js"
export * from "./orderProgress.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__